export default function TypesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('types');
}

TypesConfiguration.$inject = ['$translatePartialLoaderProvider'];
